// src/components/License.js
import React, { useState } from 'react';

function License() {
  const [showFallback, setShowFallback] = useState(false);
  
  // Reference the PDF from the public folder
  const pdfUrl = process.env.PUBLIC_URL + '/waka_license.pdf';
  
  const handleBack = () => {
    window.history.back();
  };
  
  const handleIframeError = () => {
    console.log("PDF iframe failed to load");
    setShowFallback(true);
  };
  
  const mobileButtonStyle = {
    fontSize: '16px',
    fontWeight: '600',
    height: '56px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    border: 'none',
    padding: '0 20px',
    margin: '0 5px',
    appearance: 'none',
    cursor: 'pointer',
    backgroundColor: '#2563eb',
    color: 'white'
  };
  
  return (
    <div className="container mx-auto px-4 py-6">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold">Waka Folding Technology Non-Commercial License</h1>
      </div>
      
      <div className="bg-gray-100 p-4 rounded-lg shadow-md">
        {showFallback ? (
          // Fallback content
          <div className="text-center p-8 bg-white rounded">
            <p className="mb-4">
              The license PDF could not be displayed directly in your browser.
            </p>
            <a 
              href={pdfUrl} 
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 inline-block mb-4"
            >
              Open PDF in New Tab
            </a>
          </div>
        ) : (
          // Try iframe with direct URL
          <iframe
            src={pdfUrl}
            title="Waka Folding Technology License"
            className="w-full rounded shadow-md"
            style={{ height: '70vh', border: 'none' }}
            onError={handleIframeError}
          />
        )}
        
        <div className="mt-6 text-center">
          <div className="flex flex-wrap justify-center">
            <button 
              onClick={handleBack}
              style={mobileButtonStyle}
              className="hover:bg-blue-700 m-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Back
            </button>
            
            
            <a 
              href={pdfUrl}
              download="waka-license.pdf"
              style={{
                ...mobileButtonStyle,
                backgroundColor: '#10B981',
              }}
              className="hover:bg-green-700 m-2"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Download PDF
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default License;